// extracted by mini-css-extract-plugin
export default {"floatingIcon":"CircleFloatingIcon_floatingIcon__iXPq3","Icon":"CircleFloatingIcon_Icon__vc32-","avatar":"CircleFloatingIcon_avatar__2vexI"};